
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Settings = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M12.5,8A4.5,4.5,0,1,0,17,12.5,4.5,4.5,0,0,0,12.5,8Zm0,7.5a3,3,0,1,1,3-3A2.9,2.9,0,0,1,12.5,15.5Z"></path>
            <path d="M22.8,10.7v-.6l-2.2-.2A6.1,6.1,0,0,0,20,8.7l1.4-1.8-.3-.4L19.9,5.1,18.5,3.9l-.4-.3L16.3,5l-1.2-.5-.2-2.2h-.6a10.9,10.9,0,0,0-3.6,0h-.6L9.9,4.5,8.7,5,6.9,3.6l-.4.3L5.1,5.1,3.9,6.5l-.3.4L5,8.7a6.1,6.1,0,0,0-.5,1.2l-2.2.2v.6A11,11,0,0,0,2,12.5a11,11,0,0,0,.2,1.8v.6l2.2.2A6.1,6.1,0,0,0,5,16.3L3.6,18.1l.3.4,1.2,1.4,1.4,1.2.4.3L8.7,20l1.2.5.2,2.2h.6l1.8.2,1.8-.2h.6l.2-2.2,1.2-.5,1.8,1.4.4-.3,1.4-1.2,1.2-1.4.3-.4L20,16.3a6.1,6.1,0,0,0,.5-1.2l2.2-.2v-.6a11,11,0,0,0,.2-1.8A11,11,0,0,0,22.8,10.7Zm-1.4,2.8-2.1.3v.5a5.1,5.1,0,0,1-.7,1.7l-.3.4,1.3,1.7a2.3,2.3,0,0,1-.7.7h0a2.3,2.3,0,0,1-.7.7l-1.7-1.3-.4.3a5.1,5.1,0,0,1-1.7.7h-.5l-.3,2.1a6.7,6.7,0,0,1-2,0l-.3-2.1h-.5A5.1,5.1,0,0,1,9,18.5l-.4-.3L6.9,19.5a2.3,2.3,0,0,1-.7-.7,2.3,2.3,0,0,1-.7-.7l1.3-1.7L6.5,16a5.1,5.1,0,0,1-.7-1.7v-.5l-2.1-.3a3.4,3.4,0,0,1-.1-1,3.4,3.4,0,0,1,.1-1l2.1-.3v-.5A5.1,5.1,0,0,1,6.5,9l.3-.4L5.5,6.9a2.3,2.3,0,0,1,.7-.7,2.3,2.3,0,0,1,.7-.7L8.6,6.8,9,6.5a5.1,5.1,0,0,1,1.7-.7h.5l.3-2.1a6.7,6.7,0,0,1,2,0l.3,2.1h.5a5.1,5.1,0,0,1,1.7.7l.4.3,1.7-1.3a2.3,2.3,0,0,1,.7.7,2.3,2.3,0,0,1,.7.7L18.2,8.6l.3.4a5.1,5.1,0,0,1,.7,1.7v.5l2.1.3a3.4,3.4,0,0,1,.1,1A3.4,3.4,0,0,1,21.4,13.5Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Settings.defaultProps = {
  title: 'Settings',
};

export default Settings;
